import React, { useEffect } from 'react';
import toastr from 'toastr';

// Set toastr options globally (outside the component)
toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: 'toast-top-right',
    preventDuplicates: true,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '2000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  };

  
export function ToastrNotification(message, type){
// Set a default type if not provided
const notificationType = type || 'success';

if(notificationType === 'success'){
    toastr.success(message);
}
else if(notificationType === 'error'){
    toastr.error(message);
}
else if(notificationType === 'warning'){
    toastr.warning(message);
}
  //return null; // This component doesn't render anything in the DOM
};

export default ToastrNotification;